import { render, staticRenderFns } from "./customer-picker-button.vue?vue&type=template&id=3685e9fb"
import script from "./customer-picker-button.vue?vue&type=script&lang=js"
export * from "./customer-picker-button.vue?vue&type=script&lang=js"
import style0 from "./customer-picker-button.vue?vue&type=style&index=0&id=3685e9fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports